var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-10 mb-md-20 mb-lg-28"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-10 mb-lg-0",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-badge', {
    attrs: {
      "floating": "",
      "dot": ""
    }
  }, [_c('h4', {
    staticClass: "main-tit"
  }, [_vm._v(_vm._s(_vm.title))])])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }